import Search16 from '@carbon/icons-react/es/search/16';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { View } from 'api/views/types';
import { ResizableDrawer } from 'components/atoms/drawer/resizable-drawer';
import { Input } from 'components/atoms/input';
import { useCustomerPreview } from 'hooks/use-customer-preview';
import { useTranslation } from 'hooks/use-translation';
import { useIsExternalUser } from 'hooks/use-user-type';
import { Views } from '../types';
import { Content, Header, SearchInput } from './components';
import { ViewContextProps } from './context';
import { AllViews } from './views';

interface Props<ViewDefinition = any> {
  contextValue: ViewContextProps;
  views: Views<ViewDefinition>;
  defaultViewsList: Views<ViewDefinition>;
  defaultViewId: number;
  selectedView?: View<ViewDefinition>;
  visible: boolean;
  loading: boolean;
  onClose: () => void;
  onViewEdit: (view: View<ViewDefinition>) => void;
  onViewDelete: (view: View<ViewDefinition>) => void;
  onViewSelect: (view: View<ViewDefinition>) => void;
}
export const SavedViewsSideBar: FC<Props> = ({
  contextValue,
  defaultViewId,
  defaultViewsList,
  views,
  visible,
  loading,
  selectedView,
  onClose,
  onViewSelect,
  onViewEdit,
  onViewDelete,
}) => {
  const [searchText, setSearchText] = useState('');
  const isExternalUser = useIsExternalUser();
  const searchBoxPlaceholder = useTranslation('views.search_view.placeholder');
  const { isPreview } = useCustomerPreview();

  return (
    <ResizableDrawer
      visible={visible}
      onClose={onClose}
      offset={isPreview || isExternalUser ? 255 : 48}
      minWidth={255}
      maxWidth={600}
    >
      <Header>
        <FormattedMessage id="views.saved_view.title" />
      </Header>
      {!isExternalUser && (
        <SearchInput>
          <Input
            placeholder={searchBoxPlaceholder}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            disabled={loading}
          />
          <Search16 />
        </SearchInput>
      )}
      {visible ? (
        <Content>
          <AllViews
            contextValue={contextValue}
            views={views}
            defaultViewsList={defaultViewsList}
            defaultViewId={defaultViewId}
            onViewSelect={onViewSelect}
            selectedView={selectedView}
            onViewEdit={onViewEdit}
            onViewDelete={onViewDelete}
            loading={loading}
            searchText={searchText}
          />
        </Content>
      ) : null}
    </ResizableDrawer>
  );
};
